<template>
    <div>
        <v-container fluid>
            <v-row class="p-3">
                <v-col
                        v-for="(image,index) in img"
                        :key="image.id"
                        cols="12"
                        class="p-0 mx-auto"
                        md="2"
                        :data-img="image.id"
                > <v-radio-group v-model="selectedImage">
                    <v-radio
                            color="indigo"
                            :value="image.value"
                    ></v-radio>
                </v-radio-group>
                    <v-img
                            :src="image.full_path"
                            :lazy-src="image.full_path"
                            :key="image.id"
                    ></v-img>
                    <p class="text-center mr-5">{{ image.name }}</p>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import Swal from "sweetalert2";

export default {
    name:"headerShape",
    data() {
        return {
            selectedImage: [],
            img: [
                {
                    id: '1',
                    name: 'سربرگ-افقی',
                    value: 'horizontalTriangle',
                    full_path: require('../../../../public/media/site/shape/header/سربرگ-افقی.png')
                },
                {
                    id: '2',
                    name: 'سربرگ-عمودی',
                    value: 'verticalTriangle',
                    full_path: require('../../../../public/media/site/shape/header/سربرگ عمودی.png')
                },
            ],
            count: 1,
        }
    },
    watch:{
        selectedImage() {
            this.$emit('persianName',this.img.find((x)=>x.value === this.selectedImage).name,"headerShape")
            this.$emit('input', this.selectedImage)
        }
    }
}
</script>

<style scoped>

</style>